import * as React from 'react';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import { Child, StyledThreeBounce } from './styles';
var ThreeBounce = function (_a) {
    var _b = _a.size, size = _b === void 0 ? DEFAULT_SIZE : _b, _c = _a.color, color = _c === void 0 ? DEFAULT_COLOR : _c, className = _a.className;
    return (React.createElement(StyledThreeBounce, { className: className, size: size, color: color },
        React.createElement(Child, { delay: -0.32 }),
        React.createElement(Child, { delay: -0.16 }),
        React.createElement(Child, { delay: 0 })));
};
export default ThreeBounce;
//# sourceMappingURL=index.js.map